import { NgModule, Injectable } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { ConfiguratorComponent } from './pages/configurator/configurator.component';
import { PatternComponent } from './pages/pattern/pattern.component';
import { TandemComponent } from './pages/tandem/tandem.component';

// Створюємо "тиху" стратегію, яка блокує зміну URL в браузері
@Injectable()
export class SilentLocationStrategy extends PathLocationStrategy {
  pushState(state: any, title: string, url: string, queryParams: string): void {
    // Перехоплюємо спробу Angular змінити URL і нічого не робимо
  }
  replaceState(state: any, title: string, url: string, queryParams: string): void {
    // Перехоплюємо спробу редиректу і нічого не робимо
  }
}

const routes: Routes = [
  { path: 'series', component: PatternComponent },
  { path: 'series/:code', component: ConfiguratorComponent },
  { path: 'tandem', component: TandemComponent },

  { path: '', redirectTo: 'series', pathMatch: 'full' },
  { path: '**', redirectTo: 'series', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    // Кажемо Angular використовувати нашу "тиху" стратегію замість стандартної
    { provide: LocationStrategy, useClass: SilentLocationStrategy }
  ]
})
export class AppRoutingModule { }